import { render, staticRenderFns } from "./CollectedMoneyRevenueDialog.vue?vue&type=template&id=f63c36a8&scoped=true"
import script from "./CollectedMoneyRevenueDialog.vue?vue&type=script&lang=js"
export * from "./CollectedMoneyRevenueDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f63c36a8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f63c36a8')) {
      api.createRecord('f63c36a8', component.options)
    } else {
      api.reload('f63c36a8', component.options)
    }
    module.hot.accept("./CollectedMoneyRevenueDialog.vue?vue&type=template&id=f63c36a8&scoped=true", function () {
      api.rerender('f63c36a8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/FinanceVer2/TuitionManagement/dialog/CollectedMoneyRevenueDialog.vue"
export default component.exports